import { render, staticRenderFns } from "./EditIntro.vue?vue&type=template&id=64f93454&scoped=true&"
import script from "./EditIntro.vue?vue&type=script&lang=js&"
export * from "./EditIntro.vue?vue&type=script&lang=js&"
import style0 from "./EditIntro.vue?vue&type=style&index=0&id=64f93454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f93454",
  null
  
)

export default component.exports